// --------------------------------------------------------
// DROPDOWN CUSTOM - CustomDropdown
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { useState } from "react";
import Colors from "../../constants/Colors";
import { BottomButton } from "./CustomDropdown.styled";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// DROPDOWN CUSTOM INTERFACE
// --------------------------------------------------------

export interface IItem {
  atribuivel?: any;
  label: string;
}

export interface ICustomDropdown<T extends IItem = IItem> {
  value?: any;
  onChange: (value: any) => any;
  assignRole?: () => void;
  bottomButtonAction?: () => void;
  items?: T[] | any;
  disabled?: boolean;
  multiple?: boolean;
  backgroundColor?: string;
  placeholder?: string;
  textColor?: string;
  bottomButtonMsg?: string;
  containerStyle?: any;
  style?: any;
  consideraAtribuicao?: boolean;
}

/**
/**
 * A component that renders a Custom Dropdown.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CustomDropdown = ({
  value,
  onChange,
  consideraAtribuicao = true,
  placeholder = "",
  assignRole,
  bottomButtonAction,
  items = [],
  disabled,
  multiple,
  backgroundColor = Colors.lightBlue,
  textColor = "white",
  bottomButtonMsg,
  style = {},
  containerStyle = {},
}: ICustomDropdown) => {
  // --------------------------------------------------------
  // DROPDOWN CUSTOM PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const onClickBottomButton = () => {
    if (bottomButtonAction) {
      bottomButtonAction();
    } else if (assignRole) {
      assignRole();
    }
    handleClose();
  };

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      <FormControl style={{ ...containerStyle }}>
        {value?.length === 0 && (
          <InputLabel style={{ color: Colors.SPM600 }}>
            {placeholder}
          </InputLabel>
        )}
        <Select
          size="medium"
          native={false}
          disabled={disabled}
          multiple={multiple}
          open={isOpen}
          IconComponent={() => (
            <KeyboardArrowDownIcon
              onClick={() => {
                setIsOpen(true);
              }}
              style={{ cursor: "pointer", marginRight: 1 }}
            />
          )}
          label={value?.length === 0 ? placeholder : ""}
          onOpen={handleOpen}
          onClose={handleClose}
          value={value}
          style={{
            backgroundColor: backgroundColor,
            borderRadius: 8,
            color: textColor,
            ...style,
          }}
          onChange={event => {
            onChange(event.target.value);
          }}
          renderValue={(selected: any) => selected.join("/")}
        >
          {items.map((item: any, index: any) => {
            return (
              <MenuItem key={index} value={item.label}>
                <Checkbox checked={value?.indexOf(item.label) > -1} />
                <ListItemText primary={item.label} />
              </MenuItem>
            );
          })}
          {bottomButtonMsg && (
            <BottomButton onClick={onClickBottomButton}>
              <div style={{ marginTop: 8 }}>{bottomButtonMsg}</div>
            </BottomButton>
          )}
        </Select>
      </FormControl>
    </>
  );
  // --------------------------------------------------------
};

export default CustomDropdown;
